import { render } from "./SaveJobTitle.vue?vue&type=template&id=bf4ebde8"
import script from "./SaveJobTitle.vue?vue&type=script&lang=js"
export * from "./SaveJobTitle.vue?vue&type=script&lang=js"

import exportComponent from "/home/gitlab-runner/builds/gmX3YL_q/0/internal/hrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__